// extracted by mini-css-extract-plugin
export default {"cta":"DF-z","disabled":"EF-z"};